import dayjs from 'dayjs';
// 加入季度的功能插件 https://dayjs.gitee.io/docs/zh-CN/plugin/quarter-of-year
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(quarterOfYear);
export default dayjs();
